import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { getFormValues, reduxForm } from 'redux-form';
import { Input } from '../../UI/InputElement/InputElement';
import isEmpty from '../../../../utility/IsEmptyValidator';
import SignatureCanvas from 'react-signature-canvas'
import { makeFirstLetterCapital } from '../../../../utility/utility';
import cloneDeep from 'clone-deep';
import { DateTimeField } from '../../UI/DateTimeField/DateTimeField';
import { tzDateConverterTool_V3, tzTimeConversionTool_V1, tzTimeConversionTool_V2, tzUTCDateConverterTool_V2 } from '../../../../utility/TimezoneOperations/timezoneUtility';
import TimecardCorrectionFormSkeleton from './TimecardCorrectionFormSkeleton';
import errorHandler from '../../../../utility/errorHandler/errorHandler';
var moment = require('moment');
var refreshPage = () => { window.location.reload(false); }
var pickShiftTimeMessageHandler = 'Please select required Shift date and Job'

let TimeCardCorrectionForm = (props) => {

    const { handleSubmit, isLoading, isTriggerLoader, isShiftDetailId, singleShiftScheduleData, handleCancel } = props;
    let { empSignShade } = useRef({});

    const getJobAccountSitesList = (jobAccountSitesList) => {
        if (props.jobAccountSitesList && props.jobAccountSitesList.length > 0) {
            return jobAccountSitesList && jobAccountSitesList.map((data) => {
                return {
                    value: data.id,
                    label: data.name
                }
            })
        } else {
            return []
        }
    };

    const getFrontlineUsersList = (frontlineUsersList) => {
        if (props.frontlineUsersList && props.frontlineUsersList.length > 0) {
            return frontlineUsersList && frontlineUsersList.map((data) => {
                return {
                    value: data.id,
                    label: data.first_name + ' ' + data.last_name,

                }
            })
        } else {
            return []
        }
    };

    const getCurrentDateShiftList = (currentShiftList) => {
        if (props?.getShiftListByparams?.length > 0) {
            return currentShiftList && currentShiftList.map((data) => {
                if (data.is_time_card == true) {
                    pickShiftTimeMessageHandler = 'Time card already created for this shift'
                    errorHandler('Time card already created for this shift');
                    setTimeout(() => {
                        refreshPage();
                    }, 1500);
                } else if (!(data?.check_out_at?.length > 0)) {
                    pickShiftTimeMessageHandler = 'Shift not yet clocked out'
                    errorHandler('Shift not yet clocked out');
                    setTimeout(() => {
                        refreshPage();
                    }, 1500);
                } else {
                    return {
                        value: data.id,
                        label: tzTimeConversionTool_V1(data?.shift?.start_time, data?.shift?.start_date?.split('T')[0]) + ' − ' + tzTimeConversionTool_V1(data?.shift?.end_time, data?.shift?.end_date?.split('T')[0]),
                    }
                }
            })
        } else {
            return [];
        }
    }

    const [jobSitesList, setJobSitesList] = useState(getJobAccountSitesList(props.jobAccountSitesList));
    const [frontlineUsersList, setFrontlineUsersList] = useState(getFrontlineUsersList(props.frontlineUsersList));
    const [shiftList, setShiftList] = useState(getCurrentDateShiftList(props.getShiftListByparams));

    useEffect(() => {
        setJobSitesList(getJobAccountSitesList(props.jobAccountSitesList))
    }, [props.jobAccountSitesList]);

    useEffect(() => {
        setFrontlineUsersList(getFrontlineUsersList(props.frontlineUsersList))
    }, [props.frontlineUsersList]);

    useEffect(() => {
        setShiftList(getCurrentDateShiftList(props.getShiftListByparams))
    }, [props.getShiftListByparams]);

    const handleSignature = () => {

        if (props?.formStates?.timecard?.empId !== null) {
            if (empSignShade.isEmpty() === false) {
                let empSignUrl = empSignShade.getTrimmedCanvas().toDataURL("image/png");
                let baseFile = { empSignUrl };
                props.handleEmployeeSignature(baseFile);
            }
        }

    };

    if (isTriggerLoader) {
        return (
            <TimecardCorrectionFormSkeleton />
        )
    } else {
        return (
            <>
                <main className="app-content wraper_content user_newQuote add_account_modal add_New_Accont add_newAccount">
                    <div className="inspection_content_sec appcontent_Inner">
                        <div className="container-fluids">
                            <div className="quote_form ticket_form" style={{ maxWidth: '1200px' }}>

                                <div className="row">
                                    <div className="col-sm-12 text-center"> <h2 className="md_title" > Create Timecard Correction </h2></div>
                                </div>

                                <form className="form_content" onSubmit={handleSubmit} >
                                    <div className="addQuote_form mb-3">
                                        <div className="cst_tab_content">

                                            {!(isShiftDetailId) && (
                                                <div className="addQuote_form mt-3 mb-3">
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label className="form_title fw-bold"> Shift Date <sup className="cst_sup_txt text_danger">*</sup> </label>
                                                                <div className="input-group cst_input_group col-lg-14 pl-0">
                                                                    <div style={{ width: '100%' }}>
                                                                        <Input
                                                                            name="timecard[selectedShiftDate]"
                                                                            type="date"
                                                                            datePickerType={"react-datepicker"}
                                                                            maxDate={new Date()}
                                                                            dateFormat="MM-dd-yyyy"
                                                                            className="form-control input-modifier"
                                                                            placeholder="Select Date"
                                                                        />
                                                                    </div>
                                                                    <div className="input-group-append cursor-pointer" style={{ float: "right", position: "absolute", right: 0, height: "45px", top: 0 }}>
                                                                        <span class="input-group-text" id="basic-addon2"> <i class="fa fa-calendar"></i> </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label className="form_title fw-bold"> Job <sup className="cst_sup_txt text_danger">*</sup>  </label>
                                                                <Input name="timecard[accountId]" dataTest="select_leave_type" type="inputSelect" options={jobSitesList} placeholder="Please select" onChange={(e) => {
                                                                    let userId = props?.user?.id;
                                                                    let accountId = e?.value;
                                                                    let date = tzUTCDateConverterTool_V2(props?.formStates?.timecard?.selectedShiftDate, 'none');
                                                                    props.getShiftListByParams({ userId, accountId, date });
                                                                }} />
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label className="form_title fw-bold"> Shift Time <sup className="cst_sup_txt text_danger">*</sup> </label>
                                                                {shiftList && shiftList.length > 0 && shiftList[0] !== undefined ? (
                                                                    <Input name="timecard[selectedShiftId]]" dataTest="select_leave_type" type="inputSelect" options={shiftList} onChange={(e) => {
                                                                        props.getSingleShifSchedule(e.value);
                                                                    }} placeholder="Please select" />
                                                                ) : (
                                                                    <Input name="" type="text" readOnly={true} className="form-control input-modifier" id="" placeholder={pickShiftTimeMessageHandler} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {!(singleShiftScheduleData?.id) && (
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="form-group">
                                                                    <p className="form_title fw-bold text-muted"> ***Before proceeding to create the Timecard correction form, make sure to fill out the three fields above. </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {singleShiftScheduleData?.id && (
                                                <>
                                                    <div className="addQuote_form mt-3 mb-3">

                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold"> Employee Name </label>
                                                                    <Input name="timecard[empName]" type="text" readOnly={true} className="form-control input-modifier" id="" placeholder="Type here" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold"> Employee ID# </label>
                                                                    <Input name="timecard[empMail]" type="text" readOnly={true} className="form-control input-modifier" id="" placeholder="Type here" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="addQuote_form mt-3 mb-3">

                                                        <label className="form_title font-weight-bold mb-4"> STEP 1 </label>

                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold"> Job </label>
                                                                    <Input name="timecard[accountId]" dataTest="select_leave_type" type="inputSelect" options={jobSitesList} placeholder="Please select" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold"> Shift Time </label>
                                                                    <Input name="timecard[shiftTime]" type="text" readOnly={true} className="form-control input-modifier" id="" placeholder="" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold"> Clock In </label>
                                                                    <DateTimeField name="timecard[clockIn]" timeConstraints={{ minutes: { step: 5 } }} datePickerType='react-datetime' pickerType="timePicker" dataFormat="hh:mm A" className="form-control Input-modifier" id="clockIn" />
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold"> Clock Out </label>
                                                                    <DateTimeField name="timecard[clockOut]" timeConstraints={{ minutes: { step: 5 } }} datePickerType='react-datetime' pickerType="timePicker" dataFormat="hh:mm A" className="form-control Input-modifier" id="clockOut" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {singleShiftScheduleData?.breaks?.map((time, index) => (
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="form_title fw-bold"> Meal In </label>
                                                                        <DateTimeField name={`timecard[breakIn][${index}][mealIn]`} timeConstraints={{ minutes: { step: 5 } }} datePickerType='react-datetime' pickerType="timePicker" dataFormat="hh:mm A" className="form-control Input-modifier" id="mealIn" />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <div className="form-group">
                                                                        <label className="form_title fw-bold"> Meal Out </label>
                                                                        <DateTimeField name={`timecard[breakOut][${index}][mealOut]`} timeConstraints={{ minutes: { step: 5 } }} datePickerType='react-datetime' pickerType="timePicker" dataFormat="hh:mm A" className="form-control Input-modifier" id="mealOut" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}

                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold"> Date of Error </label>
                                                                    <div className="input-group cst_input_group col-lg-14 pl-0">
                                                                        <div style={{ width: '100%' }}>
                                                                            <Input
                                                                                name="timecard[errorDate]"
                                                                                type="date"
                                                                                datePickerType={"react-datepicker"}
                                                                                minDate={new Date()}
                                                                                dateFormat="MM-dd-yyyy"
                                                                                className="form-control input-modifier"
                                                                                placeholder="Select Date"
                                                                            />
                                                                        </div>
                                                                        <div className="input-group-append cursor-pointer" style={{ float: "right", position: "absolute", right: 0, height: "45px", top: 0 }}>
                                                                            <span class="input-group-text" id="basic-addon2"> <i class="fa fa-calendar"></i> </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold"> Reason for Error <sup className="cst_sup_txt text_danger">*</sup> </label>
                                                                    <Input name="timecard[errorReason]" type="text" className="form-control input-modifier" id="" placeholder="Please enter your reason" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="addQuote_form mt-3 mb-3">

                                                        <label className="form_title font-weight-bold mb-4"> STEP 2 </label>

                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold">
                                                                        I {makeFirstLetterCapital(singleShiftScheduleData?.assignedTo?.first_name) + makeFirstLetterCapital(singleShiftScheduleData?.assignedTo?.last_name)} certify that I agree with the {`error(s)`} above, and I agree to have my payroll/record changed to reflect these corrections. I understand that failing to Following the Peg Time policy will result in discipline, up to and including termination.
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="addQuote_form mt-3 mb-3">

                                                        <label className="form_title font-weight-bold mb-4"> STEP 3 </label>

                                                        <div className="row">
                                                            <div className="col-md-12 monthly_tab">
                                                                <div className="form-group box_input">
                                                                    <label className="form_title fw-bold">
                                                                        *** For a clock Out error, the employee must complete the attestation question***
                                                                    </label>
                                                                    <label className="form_title fw-bold">
                                                                        1. I certify I was able to take my meal and rest break(s) today in accordance with state law, I performed my work today without sustaining any work injury and that my work hours are complete and accurate. (click the applicable answer)
                                                                    </label>
                                                                    <Input type="radio" labelClass="custom-control-label" forLable={"customTrue"} value={"true"} label={"Yes"} className="custom-control-input" id="customTrue" name="timecard[clkAgreement]" />
                                                                    <Input type="radio" labelClass="custom-control-label" forLable={"customFalse"} value={"false"} label={"No"} className="custom-control-input" id="customFalse" name="timecard[clkAgreement]" />
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="addQuote_form mt-3 mb-3">

                                                        <label className="form_title font-weight-bold mb-4"> STEP 4 </label>

                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold"> Employee Name </label>
                                                                    <Input name="timecard[empId]" dataTest="select_leave_type" type="inputSelect" options={frontlineUsersList} placeholder="Please select" />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-4">
                                                                <label className="form_title fw-bold"> Employee Signature <sup className="cst_sup_txt text_danger">*</sup> </label>
                                                                <div className="form-group">
                                                                    <SignatureCanvas
                                                                        ref={(ref) => { empSignShade = ref; }}
                                                                        penColor='black' backgroundColor='white'
                                                                        canvasProps={{ width: 500, height: 50, className: 'form-control textarea_modifier' }}
                                                                    />
                                                                    {/* <div style={{ display: 'flex', justifyContent: 'flex-end' }}><button type="button" onClick={clearSign} className="btn mr-2 btn-outline-secondary">Clear</button></div> */}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label className="form_title fw-bold"> Date Signed <sup className="cst_sup_txt text_danger">*</sup> </label>
                                                                    <div className="input-group cst_input_group col-lg-14 pl-0">
                                                                        <div style={{ width: '100%' }}>
                                                                            <Input
                                                                                name="timecard[empSignDate]"
                                                                                type="date"
                                                                                datePickerType={"react-datepicker"}
                                                                                minDate={new Date()}
                                                                                dateFormat="MM-dd-yyyy"
                                                                                className="form-control input-modifier"
                                                                                placeholder="Select Date"
                                                                            />
                                                                        </div>
                                                                        <div className="input-group-append cursor-pointer" style={{ float: "right", position: "absolute", right: 0, height: "45px", top: 0 }}>
                                                                            <span class="input-group-text" id="basic-addon2"> <i class="fa fa-calendar"></i> </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </>
                                            )}

                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        {singleShiftScheduleData.id && <button data-test="submit_button" type="submit" disabled={isLoading} className={isLoading ? "btn cst_btn btn_danger btn-wait w-25" : "btn cst_btn btn_danger w-25"} onClick={handleSignature}>{isLoading ? "" : "Submit"}</button>}
                                        {isShiftDetailId && <button data-test="cancel_button" type="button" className="btn cst_btn btn-outline-secondary cancel_btnnew w-25" onClick={handleCancel}> Back </button>}
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </main>
            </>
        );
    }

};

const mapStateToProps = (state, props) => {

    let timecard = {};

    /* For fetching Job Name */
    const getJobObject = (user) => {
        let fetchedJobObject = null;
        fetchedJobObject = {
            value: user.id,
            label: makeFirstLetterCapital(user.name)
        }
        return fetchedJobObject;
    };

    /* For fetching  Name */
    const getAllocatedShiftObject = (shift) => {
        let fetchedShiftObject = null;
        props.getShiftListByparams.map((mapedItem) => {
            if (mapedItem?.shift?.id == shift.id) {
                fetchedShiftObject = {
                    value: shift.id,
                    label: shift.time
                }
            }
        });
        return fetchedShiftObject;
    };

    if (isEmpty(state.TimeTrackerModReducer.singleShiftScheduleData)) {

        timecard = {
        }

    } else {

        let catchedFormValues = state?.form?.newTimeCardCorrectionForm?.values?.timecard;
        const value = cloneDeep(state.TimeTrackerModReducer.singleShiftScheduleData);

        let breakInSlots = value.breaks.map((mealBreak) => {
            return { id: mealBreak?.id, mealIn: mealBreak?.start ? tzTimeConversionTool_V2(mealBreak?.start.split('T')[1].split('.')[0], mealBreak?.start.split('T')[0]) : '' }
        });

        let breakOutSlots = value.breaks.map((mealBreak) => {
            return { id: mealBreak?.id, mealOut: mealBreak?.end ? tzTimeConversionTool_V2(mealBreak?.end.split('T')[1].split('.')[0], mealBreak?.end.split('T')[0]) : '' }
        });

        timecard = {
            selectedShiftDate: catchedFormValues?.selectedShiftDate ? catchedFormValues.selectedShiftDate : '',
            selectedShiftId: value?.shift?.id ? getAllocatedShiftObject({ id: value.shift.id, time: tzTimeConversionTool_V1(value?.shift?.start_time, value?.shift?.start_date?.split('T')[0]) + ' − ' + tzTimeConversionTool_V1(value?.shift?.end_time, value?.shift?.end_date?.split('T')[0]) }) : '',

            empName: value?.assignedTo?.id ? makeFirstLetterCapital(value.assignedTo.first_name) + makeFirstLetterCapital(value.assignedTo.last_name) : '',
            empMail: value?.assignedTo?.id ? value.assignedTo.id : '',
            accountId: value?.accounts?.[0] ? getJobObject(value.accounts[0]) : '',
            shiftTime: value?.shift?.id ? tzTimeConversionTool_V1(value?.shift?.start_time, value?.shift?.start_date?.split('T')[0]) + ' − ' + tzTimeConversionTool_V1(value?.shift?.end_time, value?.shift?.end_date?.split('T')[0]) : '',
            clockIn: value?.check_int_at !== null ? tzTimeConversionTool_V2(value.check_int_at.split('T')[1].split('.')[0], value.date.split('T')[0]) : '',
            clockOut: value?.check_out_at !== null ? tzTimeConversionTool_V2(value.check_out_at.split('T')[1].split('.')[0], value.date.split('T')[0]) : '',
            breakIn: breakInSlots?.length > 0 ? breakInSlots : [],
            breakOut: breakOutSlots?.length > 0 ? breakOutSlots : [],
            errorDate: value?.date ? tzDateConverterTool_V3(value.date) : '',
            clkAgreement: 'true',
            empId: value?.assignedTo?.id ? { value: `${value.assignedTo.id}`, label: `${value.assignedTo.first_name + ' ' + value.assignedTo.last_name}` } : '',
            // empSignDate: value?.id ? tzDateConverterTool_V3(moment().format('YYYY-MM-DDTHH:mm:ss')) : null,
        }

    }

    return {
        initialValues: { timecard },
        formStates: getFormValues('newTimeCardCorrectionForm')(state)
    }

}

TimeCardCorrectionForm = reduxForm({
    form: 'newTimeCardCorrectionForm',
    // validate,
    enableReinitialize: true
})(TimeCardCorrectionForm);

TimeCardCorrectionForm = connect(mapStateToProps)(TimeCardCorrectionForm)

export default TimeCardCorrectionForm;